/* eslint-disable camelcase */
import {
  SET_ALL_SERVICES,
  SET_TIME_SLOTS,
  SET_EMPLOYEE_SELECTED,
  SET_CONFIRMATION_PAGE,
  BOOK_APPOINTMENT_RESET,
  RESET_CONTINUE_BOOKING_DATA,
} from "../constants/ActionTypes";

const initialState = {
  employees_working: [],
  services_offered: [],
  weekSlot: {},
  employeesOfService: [],
  operations: {},
  businessName: "",
  // businessId: "",
  customerDetails: {},
  businesslocationId: "",
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ALL_SERVICES: {
      const {
        employees_working,
        services_offered,
        operations,
        business_name,
        businesslocation_id,
      } = payload;
      return {
        ...state,
        employees_working: employees_working.filter(item => item.enabled !== false),
        services_offered,
        operations,
        businessName: business_name,
        businesslocationId: businesslocation_id,
        // businessId: business_id,
      };
    }
    case SET_TIME_SLOTS: {
      return {
        ...state,
        weekSlot: payload,
      };
    }

    case SET_EMPLOYEE_SELECTED: {
      return {
        ...state,
        employeesOfService: payload,
      };
    }
    case SET_CONFIRMATION_PAGE: {
      return {
        ...state,
        customerDetails: payload,
      };
    }

    case BOOK_APPOINTMENT_RESET:
      return { ...initialState };

    case RESET_CONTINUE_BOOKING_DATA:
      return {
        ...state,
        weekSlot: {}
      }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/BookAppointment.js